import { FunctionComponent, useCallback } from "react";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { Text } from "@ui-kit/Text/Text";
import { useTranslation } from "react-i18next";
import { OnboardingStepProps } from "../OnboardingScreens/OnboardingStepProps";
import { OnboardingMenuItems } from "../OnboardingMenuItems/OnboardingMenuItems";
import { getMapUrl } from "../OnboardingScreens/getMapUrl";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { AiButton } from "@modules/components/buttons/AiButton/AiButton";
import { selectIsTripBuilderEnabled } from "@store/client/clientReducer";
import { useAppSelector } from "@store/store";

const Intro: FunctionComponent<OnboardingStepProps> = ({
  onNextPress,
  onClose,
  entity,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const isTripBuilderEnabled = useAppSelector(selectIsTripBuilderEnabled);

  const handleCreatePlanPress = useCallback(() => {
    onNextPress("createPlan");
  }, [onNextPress]);

  const handleLaterPress = useCallback(() => {
    if (entity) {
      onNextPress("featuredItem");
    } else {
      onClose();
    }
  }, [entity, onClose, onNextPress]);

  return (
    <div className="content-container">
      <div className="title-description">
        <Text variant="fontHeadingXlarge">
          {t("screens.onboarding.introTitle")}
        </Text>
        <Text variant="fontBodyLarge">
          {t("screens.onboarding.introDescription")}
        </Text>
      </div>
      <div
        className={
          isTripBuilderEnabled
            ? "actions-horizontal-reverse"
            : "actions-vertical"
        }>
        <TabButton
          variant="primary"
          wide={true}
          flex={isMobile || isTripBuilderEnabled}
          label={t("screens.onboarding.createAPlanButton")}
          onPress={handleCreatePlanPress}
        />
        <TabButton
          variant="inverse"
          active={true}
          wide={true}
          flex={isMobile || isTripBuilderEnabled}
          label={t("screens.onboarding.laterButton")}
          onPress={handleLaterPress}
        />
      </div>
      {isTripBuilderEnabled && (
        <div className="trip-builder-container">
          <div className="trip-builder-description">
            <Text variant="fontHeadingXsmall">
              {t("ai.tripBuilder.launch.title")}
            </Text>
            <Text variant="fontBodyMedium">
              {t("ai.tripBuilder.launch.description")}
            </Text>
          </div>
          <AiButton
            label={t("ai.tripBuilder.launch.helpMePlan")}
            flex={false}
          />
        </div>
      )}
    </div>
  );
};

const IntroBackground: FunctionComponent = () => {
  const mapUrl = getMapUrl();

  return (
    <>
      <div
        style={{
          zIndex: -1,
          position: "absolute",
          inset: 0,
          background: `url(${mapUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}></div>
      <div className="onboarding-background-image-overlay onboarding-background-color">
        <OnboardingMenuItems />
      </div>
    </>
  );
};

export { Intro, IntroBackground };
